import './../scss/style.scss';
//  import Bootstrap 
require('bootstrap');

import { WCAG } from "rytm-wcag";
import { initCommon } from './shared/common';
import { initCookies } from './shared/cookies';
import { initOffcanvas } from './shared/offcanvas';
import { initPrintShare } from './shared/print-share';
import { initASwap } from './aswap';

WCAG.init();
initCommon();
initCookies();
initOffcanvas();
initPrintShare();
initASwap();
setTimeout(() => {
  document.documentElement.classList.remove("index-loading");
}, 50);